module.exports = __webpack_public_path__ + "hyperion-v2-static/img/no_data_blue.ddb7af18.png";